export default class Step {
  constructor($step, $container) {
    this.timestamp = new Date().getTime() + (Math.random() * 10000);
    this.$step = $step;
    this._$container = $container;
    this.isValid = true;
    this._$summary = this.$step.querySelector('.step-summary');
    this.dataRequiredStep = this.$step.dataset.stepRequired;
    this._requiredStep = undefined;
  }

  addEventListener(event, functionCallback) {
    $(this.$step).on(event, (ev) => functionCallback(ev));
  }

  selectCount() {
    return this.$step.dataset.select;
  }

  updateSummary(summary) {
    this._$summary.innerHTML = summary;
  }

  clear() {
    this._$summary.innerHTML = '';
  }

  update() {
    if (!!this._requiredStep)
      this.$step.classList.toggle('disabled', !this._requiredStep.valid);

    $(this.$step).trigger('change');
  }

  set valid(newValue) {
    this.isValid = newValue && true;
    this.$step.classList.toggle('valid', newValue);
    this.$step.classList.toggle('invalid', !newValue);
    this.update();
  }

  get valid() {
    let requiredStepValid = !!this._requiredStep ? this._requiredStep.valid : true;
    return this.isValid && requiredStepValid;
  }

  set requiredStep(step) {
    this._requiredStep = step;
    $(this._requiredStep).on('change', () => this.update());
  }

  get requiredStep() {
    return this._requiredStep;
  }
}